import uid from "common/utils/uid";
import { unmarshalTypedArraysInObject } from "common/utils/unmarshalTypedArraysInObject";
import { polyLine2New } from "geom/polyLine2Types";
import type { DocMigration } from "../docMigration";
import { addParamConfig } from "../docMigrationUtils";

export const defaultMigration: DocMigration = {
  // applies to all versions
  maxSchemaVersion: "999.999.999",
  apply(json: any) {
    json = unmarshalTypedArraysInObject(json);

    // turns the room outlines into Float64Arrays
    for (const blockId in json.blocks) {
      const block = json.blocks[blockId];
      if (!block.layouts) {
        continue;
      }

      for (const blockLayoutId in block.layouts) {
        const blockLayout = block.layouts[blockLayoutId];
        for (const locationId in blockLayout.rooms) {
          const room = blockLayout.rooms[locationId];

          room.outline = polyLine2New(room.outline);

          if (room.params === undefined) {
            continue;
          }

          for (const paramId in room.params) {
            addParamConfig(paramId, room.params[paramId]);
          }
        }
      }
    }

    // update facade span strata and sweep strata to have ids & names
    for (const facadeId in json.facades) {
      const facade = json.facades[facadeId];

      if (facade.spanStrata) {
        for (const spanStrata of facade.spanStrata) {
          if (!spanStrata.id) {
            spanStrata.id = uid();
          }
          if (!spanStrata.name) {
            spanStrata.name = `${spanStrata.material}`;
          }
        }
      }

      if (facade.sweepStrata) {
        for (const sweepStrata of facade.sweepStrata) {
          if (!sweepStrata.id) {
            sweepStrata.id = uid();
          }
          if (!sweepStrata.name) {
            sweepStrata.name = `${sweepStrata.material}`;
          }
        }
      }
    }

    return json;
  },
};
